import managerData from './shared/state';

export default {
  modules: {
    managerData,
  },
};
